export default "__VITE_ASSET__Bn9HhZBa__"